module.exports = __webpack_public_path__ + "static/media/homepage-video.d54bc3ea.mp4";